import { ColumnType } from 'antd/es/table'
import { REPORT_DATE_TYPES, REPORT_NUMBER_TYPES, ReportColumnType } from 'Components/UI/EAReport/constants'

export interface EAReportColumn<T = object, TDetail = T> extends ColumnType<T> {
  type?: ReportColumnType
  exportRender?: (value: unknown, record: Record<string, unknown>) => string | number
  exportable?: boolean
  summary?: boolean
  avg?: boolean
  quantity_column?: string
  columns?: EAReportColumn<TDetail>[]
}

const appendDateColumnProperties = <T extends object>(column: EAReportColumn<T>): EAReportColumn<T> => {
  const { dataIndex } = column as { dataIndex: string }

  return {
    render: (_, record) => (record as Record<string, unknown>)[`${dataIndex}_str`] as string,
    sorter: (a, b) => {
      const aVal = (a as Record<string, unknown>)[`${dataIndex}_unix`] as number
      const bVal = (b as Record<string, unknown>)[`${dataIndex}_unix`] as number
      return aVal - bVal > 0 ? 1 : -1
    },
    ...column,
  }
}

const appendNumberColumnProperties = <T extends object>(column: EAReportColumn<T>): EAReportColumn<T> => {
  const { dataIndex } = column as { dataIndex: string }

  return {
    render: (_, record) => (record as Record<string, unknown>)[`${dataIndex}_str`] as string,
    sorter: (a, b) => {
      const aVal = (a as Record<string, unknown>)[`${dataIndex}_num`] as number
      const bVal = (b as Record<string, unknown>)[`${dataIndex}_num`] as number
      return aVal - bVal > 0 ? 1 : -1
    },
    ...column,
  }
}

const appendColumnPropertiesByType = <T extends object>(column: EAReportColumn<T>): EAReportColumn<T> => {
  if (column.type && REPORT_DATE_TYPES.includes(column.type as never)) return appendDateColumnProperties(column)

  if (column.type && REPORT_NUMBER_TYPES.includes(column.type as never)) return appendNumberColumnProperties(column)

  return column
}

export default appendColumnPropertiesByType
